import { useState } from 'react';
import { Flex } from '../../styles/stylesStyled';
import Spinner from '../../components/common/Spinner';
import { AnimatePresence } from 'framer-motion';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { AnimatedDashboard } from '../../components/animation/AnimatedDashboard';
import {
  getConversions,
  getInvoices,
  getTransactions,
  getWithdrawals
} from '../../slices/accounting-slice';
import { PageTitle, TabSelectButton } from '../../styles/GlobalComponents';
import { InvoicesPage } from './sections/Invoices';
import { TransactionsPage } from './sections/Transactions';
import { WithdrawalsPage } from './sections/Withdrawals';
import { ConversionsPage } from './sections/TopUps';
import { Tabs } from '../MyTeamBackoffice/MyTeamBackofficeStyled';

const Accounting = () => {
  const { t } = useTranslation('accounting');
  const dispatch = useAppDispatch();
  const { invoices, transactions, withdrawals, conversions, loading } =
    useAppSelector((state) => state.accounting);

  const [tab, setTab] = useState(1);
  const [countInvoices, setCountInvoices] = useState(50);
  const [countTransactions, setCountTransactions] = useState(50);
  const [countWithdrawals, setCountWithdrawals] = useState(50);
  const [countConversions, setCountConversions] = useState(50);
  const [lastWeekStartDate, setLastWeekStartDate] = useState<number | null>(
    null
  );
  const numberOfPage = 1;

  useEffect(() => {
    if (tab === 1) {
      if (countInvoices <= 100) {
        dispatch(getInvoices({ countInvoices, lastWeekStartDate }));
      }
    } else if (tab === 2) {
      if (countTransactions <= 100) {
        dispatch(getTransactions({ countTransactions, numberOfPage }));
      }
    } else if (tab === 3) {
      if (countWithdrawals <= 100) {
        dispatch(getWithdrawals({ countWithdrawals, numberOfPage }));
      }
    } else if (tab === 4) {
      if (countWithdrawals <= 100) {
        dispatch(getConversions({ countConversions, numberOfPage }));
      }
    }
  }, [
    dispatch,
    tab,
    countInvoices,
    countTransactions,
    countWithdrawals,
    lastWeekStartDate
  ]);

  if (loading) return <Spinner fullScreen={true} />;

  return (
    <AnimatedDashboard zoom>
      <div style={{ marginBottom: 100 }}>
        <PageTitle>{t('accounting')}</PageTitle>

        <Tabs>
          <TabSelectButton selected={tab === 1} onClick={() => setTab(1)}>
            <div>{t('invoices')}</div>
          </TabSelectButton>
          <TabSelectButton selected={tab === 2} onClick={() => setTab(2)}>
            <div>{t('transactions')}</div>
          </TabSelectButton>
          <TabSelectButton selected={tab === 3} onClick={() => setTab(3)}>
            <div>{t('withdrawals')}</div>
          </TabSelectButton>
          <TabSelectButton selected={tab === 4} onClick={() => setTab(4)}>
            <div>{t('top_ups')}</div>
          </TabSelectButton>
        </Tabs>
        <AnimatePresence exitBeforeEnter>
          {tab === 1 && (
            <InvoicesPage
              invoices={invoices}
              setLastWeekStartDate={setLastWeekStartDate}
              setCountInvoices={setCountInvoices}
              countInvoices={countInvoices}
            />
          )}

          {tab === 2 && (
            <TransactionsPage
              transactions={transactions}
              setCountTransactions={setCountTransactions}
              countTransactions={countTransactions}
            />
          )}

          {tab === 3 && (
            <WithdrawalsPage
              withdrawals={withdrawals}
              setCountWithdrawals={setCountWithdrawals}
              countWithdrawals={countTransactions}
            />
          )}

          {tab === 4 && (
            <ConversionsPage
              conversions={conversions}
              setCountConversions={setCountConversions}
              countConversions={countConversions}
            />
          )}
        </AnimatePresence>
      </div>
    </AnimatedDashboard>
  );
};

export default Accounting;
